import { render, staticRenderFns } from "./AccordionList.vue?vue&type=template&id=9ac98582&scoped=true&lang=pug"
import script from "./AccordionList.vue?vue&type=script&lang=ts"
export * from "./AccordionList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ac98582",
  null
  
)

export default component.exports